<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-7 col-md-7 col-sm-7 m-0 p-0">
      <div class="modal-login-content">
        <ul class="nav nav-tabs" id="loginTab" role="tablist">
          <li class="nav-item text-center" role="presentation">
            <a class="nav-link" [class.active]="type == 'signup'" id="signup-tab" data-toggle="tab" href="#signup" role="tab"
               aria-controls="signup" aria-selected="true" [dir]="languageService.getDir()">
              {{'LOGIN_MODAL.SIGNUP.TAB' | translate}}
            </a>
          </li>
          <li class="nav-item text-center" role="presentation">
            <a class="nav-link" [class.active]="type == 'login'" id="login-tab" data-toggle="tab" href="#login" role="tab"
               aria-controls="login" aria-selected="false" [dir]="languageService.getDir()">
              {{'LOGIN_MODAL.LOGIN.TAB' | translate}}
            </a>
          </li>
        </ul>
        <div class="tab-content" id="loginTabContent">
          <div class="tab-pane fade" [class.show]="type == 'signup'" [class.active]="type == 'signup'"
               id="signup" role="tabpanel" aria-labelledby="signup-tab">
            <form *ngIf="!isSignUpSuccess" class="modal-signup-form" name="signUpForm"
                  (ngSubmit)="sf.form.valid && onSignUpSubmit()" #sf="ngForm" novalidate>
              <div class="input-group">
                <input type="email" name="email" class="form-control text-right"
                       id="inputSignupEmail" aria-describedby="emailHelp"
                       placeholder="{{'LOGIN_MODAL.SIGNUP.EMAIL' | translate}}"
                       [(ngModel)]="signUpForm.email"
                       required email #email="ngModel" [dir]="languageService.getDir()">
                <div class="input-group-append">
                  <div class="input-group-text"><span><i class="fa-solid fa-at"></i></span></div>
                </div>
                <div class="alert-danger" *ngIf="sf.submitted && email.invalid">
                  <div *ngIf="email.errors.required">Email is required</div>
                  <div *ngIf="email.errors.email">Email must be a valid email address</div>
                </div>
              </div>
              <div class="input-group">
                <input type="text" class="form-control text-right"
                       id="inputSignupPhone" placeholder="{{'LOGIN_MODAL.SIGNUP.PHONE' | translate}}"
                       [(ngModel)]="signUpForm.phone" required phone #phone="ngModel" [dir]="languageService.getDir()">
                <div class="alert-danger" *ngIf="sf.submitted && phone.invalid">
                  <div *ngIf="phone.errors.required">Phone number is required</div>
                  <div *ngIf="phone.errors.phone">Must be a valid phone number</div>
                </div>
                <div class="input-group-append">
                  <div class="input-group-text"><span><i class="fas fa-phone"></i></span></div>
                </div>
              </div>
              <div class="form-row">
                <div class="input-group input-name">
                  <input type="text" name="firstname" class="form-control text-right" id="inputFirstName"
                         placeholder="{{'LOGIN_MODAL.SIGNUP.FIRSTNAME' | translate}}"
                         [(ngModel)]="signUpForm.firstname" required minlength="2"
                         maxlength="20" #firstname="ngModel" [dir]="languageService.getDir()">
                  <div class="input-group-append">
                    <div class="input-group-text"><span><i class="fas fa-user"></i></span></div>
                  </div>
                  <div class="alert-danger" *ngIf="sf.submitted && firstname.invalid">
                    <div *ngIf="firstname.errors.required">First name is required</div>
                    <div *ngIf="firstname.errors.minlength">First name must be at least 2 characters</div>
                    <div *ngIf="firstname.errors.maxlength">First name must be at most 20 characters</div>
                  </div>
                </div>
                <div class="input-group input-name">
                  <input type="text" name="lastname" class="form-control text-right" id="inputLastName"
                         placeholder="{{'LOGIN_MODAL.SIGNUP.LASTNAME' | translate}}"
                         [(ngModel)]="signUpForm.lastname" required minlength="2"
                         maxlength="20" #lastname="ngModel" [dir]="languageService.getDir()">
                  <div class="input-group-append">
                    <div class="input-group-text"><span><i class="fas fa-user"></i></span></div>
                  </div>
                  <div class="alert-danger" *ngIf="sf.submitted && lastname.invalid">
                    <div *ngIf="lastname.errors.required">Last name is required</div>
                    <div *ngIf="lastname.errors.minlength">Last name must be at least 2 characters</div>
                    <div *ngIf="lastname.errors.maxlength">Last name must be at most 20 characters</div>
                  </div>
                </div>
              </div>
              <div class="input-group">
                <input type="password" class="form-control text-right" id="inputSignupPassword"
                       placeholder="{{'LOGIN_MODAL.SIGNUP.PASSWORD' | translate}}"
                       [(ngModel)]="signUpForm.password" required minlength="6"
                       #password="ngModel" [dir]="languageService.getDir()">
                <div class="input-group-append">
                  <div class="input-group-text"><span><i class="fas fa-key"></i></span></div>
                </div>
                <div class="alert-danger" *ngIf="sf.submitted && password.invalid">
                  <div *ngIf="password.errors.required">Password is required</div>
                  <div *ngIf="password.errors.minlength">Password must be at least 6 characters</div>
                </div>
              </div>
              <div class="input-group">
                <input type="password" class="form-control text-right" id="confirmSignupPassword"
                       placeholder="{{'LOGIN_MODAL.SIGNUP.PASSWORD_CONFIRM' | translate}}"
                       [(ngModel)]="signUpForm.passwordConfirm" required
                       minlength="6" #passwordConfirm="ngModel" [dir]="languageService.getDir()">
                <div class="input-group-append">
                  <div class="input-group-text"><span><i class="fas fa-key"></i></span></div>
                </div>
                <div class="alert-danger" *ngIf="sf.submitted && passwordConfirm.invalid">
                  <div *ngIf="passwordConfirm.errors.required">Confirm Password is required</div>
                  <div *ngIf="passwordConfirm.errors.minlength">Confirm Password must be at least 6 characters</div>
                </div>
              </div>
              <div class="form-buttons">
                <button type="submit" class="btn btn-default submit-button" [dir]="languageService.getDir()">
                  {{'LOGIN_MODAL.SIGNUP.SUBMIT' | translate}}
                </button>
              </div>
              <div class="alert alert-warning" *ngIf="sf.submitted && isSignUpFailed">
                Signup failed!<br />{{ errorMessage }}
              </div>
            </form>
          </div>
          <div class="tab-pane fade" [class.show]="type == 'login'" [class.active]="type == 'login'"
               id="login" role="tabpanel" aria-labelledby="login-tab">
            <form *ngIf="!isLoggedIn" class="modal-login-form" name="loginForm"
                  (ngSubmit)="lf.form.valid && onLoginSubmit()" #lf="ngForm" novalidate>
              <div class="input-group">
                <input type="email" class="form-control text-right" id="inputEmail" aria-describedby="emailHelp"
                       placeholder="{{'LOGIN_MODAL.LOGIN.EMAIL' | translate}}"
                       [(ngModel)]="loginForm.username" required #username="ngModel" [dir]="languageService.getDir()">
                <div class="input-group-append">
                  <div class="input-group-text"><span><i class="fa-solid fa-at"></i></span></div>
                </div>
                <div class="alert alert-danger" role="alert" *ngIf="lf.submitted && username.invalid">
                  Username is required!
                </div>
              </div>
              <div class="input-group">
                <input type="password" class="form-control text-right" id="inputPassword"
                       placeholder="{{'LOGIN_MODAL.LOGIN.PASSWORD' | translate}}"
                       [dir]="languageService.getDir()"
                       [(ngModel)]="loginForm.password"
                       required minlength="6" #password="ngModel">
                <div class="input-group-append">
                  <div class="input-group-text"><span><i class="fas fa-key"></i></span></div>
                </div>
                <div class="alert alert-danger" role="alert" *ngIf="lf.submitted && password.invalid">
                  <div *ngIf="password.errors.required">Password is required</div>
                  <div *ngIf="password.errors.minlength">Password must be at least 6 characters</div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="rememberMe" [(ngModel)]="loginForm.rememberMe">
                  <label class="form-check-label" for="rememberMe" [dir]="languageService.getDir()">
                    {{'LOGIN_MODAL.LOGIN.REMEMBER_ME' | translate}}
                  </label>
                </div>
                <div class="forgot-link text-right" [dir]="languageService.getDir()">
                  <a [routerLink]="['/password/reset_token']" (click)="closeModal('dismiss')">{{'LOGIN_MODAL.LOGIN.FORGOT_PASSWORD' | translate}}</a>
                </div>
              </div>
              <div class="form-buttons">
                <button type="submit" class="btn btn-default submit-button" [dir]="languageService.getDir()">
                  {{'LOGIN_MODAL.LOGIN.SUBMIT' | translate}}
                </button>
                <div class="form-group">
                  <div class="alert alert-danger" role="alert" *ngIf="lf.submitted && isLoginFailed">Login failed: {{ errorMessage }}</div>
                </div>
<!--                <button type="button" class="btn btn-danger social-login-button"-->
<!--                        (click)="googleLogin()" [dir]="languageService.getDir()">-->
<!--                  {{'LOGIN_MODAL.LOGIN.SIGN_IN_GOOGLE' | translate}}-->
<!--                </button>-->
<!--                <button type="button" class="btn btn-primary social-login-button"-->
<!--                        (click)="facebookLogin()" [dir]="languageService.getDir()">-->
<!--                  {{'LOGIN_MODAL.LOGIN.SIGN_IN_FACEBOOK' | translate}}-->
<!--                </button>-->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-5 col-md-5 col-sm-5 m-0 p-0">
      <div class="modal-login-image" [style]="{'background-image':'url(assets/img/login/1N9A9435.jpg)'}"></div>
    </div>
  </div>
</div>
